import { render, staticRenderFns } from "./ques71.vue?vue&type=template&id=056ffd92"
import script from "./ques71.vue?vue&type=script&lang=js"
export * from "./ques71.vue?vue&type=script&lang=js"
import style0 from "./ques71.vue?vue&type=style&index=0&id=056ffd92&prod&lang=css"
import style1 from "./ques71.vue?vue&type=style&index=1&id=056ffd92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports